import axios from "axios";
import generarFacturaJson from "../helpers/generarFacturaJson";

const getPuntos = async dni => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  const idTalonarioB = +localStorage.getItem("idTalonarioB");

  console.log(puesto);

  const requestData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    datos: {
      cabecera: {
        TipoComprobante: "Factura",
        LetraComprobante: "",
        IdTalonario: idTalonarioB,
        IdPuesto: puesto.idPuesto,
        NumeroDocumento: dni,
      },
      detalle: [],
      despachosSeleccionados: [],
    },
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/TarjetasCredito/ConsultarSaldoShellBox`, requestData);
  return response.data;
};

const acumulaPuntos = async dni => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const totalProductos = JSON.parse(localStorage.getItem("totalProductos"));
  const prefijo = localStorage.getItem("prefijoFront") || null;
  const clienteString = localStorage.getItem("cliente");
  const cliente = clienteString ? JSON.parse(clienteString) : null;
  const CuponClover = JSON.parse(localStorage.getItem("CuponClover"));
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  let facturaJsonPuntos = generarFacturaJson(CuponClover, puesto, cliente, facturaInfo, totalProductos, prefijo, null);
  console.log(facturaJsonPuntos);

  facturaJsonPuntos.detalle = facturaJsonPuntos.detalle.map(articulo => ({
    ...articulo,
    IdMangueraSeleccionada: null,
    DespachoManual: false,
  }));

  const userData = {
    nic: formattedNic,
    token: token,
    datos: facturaJsonPuntos,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Facturacion/SugerirAcumularLatamPass`, userData);
  return response;
};

const sugerirRedimirLatamPass = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const totalProductos = JSON.parse(localStorage.getItem("totalProductos"));
  const prefijo = localStorage.getItem("prefijoFront") || null;
  const clienteString = localStorage.getItem("cliente");
  const cliente = clienteString ? JSON.parse(clienteString) : null;
  const CuponClover = JSON.parse(localStorage.getItem("CuponClover"));
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  let facturaJsonPuntos = generarFacturaJson(CuponClover, puesto, cliente, facturaInfo, totalProductos, prefijo, null);
  console.log(facturaJsonPuntos);

  facturaJsonPuntos.detalle = facturaJsonPuntos.detalle.map(articulo => ({
    ...articulo,
    IdMangueraSeleccionada: null,
    DespachoManual: false,
  }));

  const userData = {
    nic: formattedNic,
    token: token,
    datos: facturaJsonPuntos,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Fidelizacion/sugerirRedimirLatamPass`, userData);

  return response;
};

const acumularOFidelizarVenta = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const totalProductos = JSON.parse(localStorage.getItem("totalProductos"));
  const prefijo = localStorage.getItem("prefijoFront") || null;
  const clienteString = localStorage.getItem("cliente");
  const cliente = clienteString ? JSON.parse(clienteString) : null;
  const CuponClover = JSON.parse(localStorage.getItem("CuponClover"));
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  let facturaJsonPuntos = generarFacturaJson(CuponClover, puesto, cliente, facturaInfo, totalProductos, prefijo, null);
  console.log(facturaJsonPuntos);

  facturaJsonPuntos.detalle = facturaJsonPuntos.detalle.map(articulo => ({
    ...articulo,
    IdMangueraSeleccionada: null,
    DespachoManual: false,
  }));

  const userData = {
    nic: formattedNic,
    token: token,
    datos: facturaJsonPuntos,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Fidelizacion/acumularOFidelizarVenta`, userData);

  return response;
};

const redimirVenta = async premio => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const totalProductos = JSON.parse(localStorage.getItem("totalProductos"));
  const prefijo = localStorage.getItem("prefijoFront") || null;
  const clienteString = localStorage.getItem("cliente");
  const cliente = clienteString ? JSON.parse(clienteString) : null;
  const CuponClover = JSON.parse(localStorage.getItem("CuponClover"));
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  let facturaJsonPuntos = generarFacturaJson(CuponClover, puesto, cliente, facturaInfo, totalProductos, prefijo, null);

  facturaJsonPuntos.premio = premio;

  facturaJsonPuntos.detalle = facturaJsonPuntos.detalle.map(articulo => ({
    ...articulo,
    IdMangueraSeleccionada: null,
    DespachoManual: false,
  }));

  const userData = {
    nic: formattedNic,
    token: token,
    datos: facturaJsonPuntos,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Fidelizacion/redimirVenta`, userData);
  return response;
};

const ConsultarSaldoShellBox = {
  getPuntos,
  acumulaPuntos,
  sugerirRedimirLatamPass,
  acumularOFidelizarVenta,
  redimirVenta,
};

export default ConsultarSaldoShellBox;
